export default {
  SET_LAYOUT: 'SET_LAYOUT',
  SET_CONFIG: 'SET_CONFIG',
  ADD_BET: 'ADD_BET',
  REMOVE_BET: 'REMOVE_BET',
  EMPTY_BETSLIP: 'EMPTY_BETSLIP',
  SET_MIN_TOTAL_STAKE: 'SET_MIN_TOTAL_STAKE',
  SET_TOTAL_STAKE: 'SET_TOTAL_STAKE',
  SPLIT_STAKE_PER_BET: 'SPLIT_STAKE_PER_BET',
  SET_TAXES: 'SET_TAXES',
  UPDATE_TAXES: 'UPDATE_TAXES',
  SET_FUTURE_BETS: 'SET_FUTURE_BETS',
  SHOW_HIDE_BETSLIP: 'SHOW_HIDE_BETSLIP',
  UPDATE_TICKET_ROUND_INFO: 'UPDATE_TICKET_ROUND_INFO',
  TOGGLE_PAYIN_ACTION: 'TOGGLE_PAYIN_ACTION',
  SET_TICKET_RULES: 'SET_TICKET_RULES',
  SET_BALANCE_VALUE: 'SET_BALANCE_VALUE',
  GO_TO_DETAIL_BET: 'GO_TO_DETAIL_BET',
  RESET_SELECTED_BET: 'RESET_SELECTED_BET',

  ADD_BET_ITEM: 'ADD_BET_ITEM',
  REMOVE_BET_ITEM: 'REMOVE_BET_ITEM',
  REMOVE_ALL_ITEMS: 'REMOVE_ALL_ITEMS',
  GET_CURRENT_BET_ITEM: 'GET_CURRENT_BET_ITEM',
  CHECK_BALANCE: 'CHECK_BALANCE',

  SET_BET_MIN_PAYMENT: 'SET_BET_MIN_PAYMENT',
  SET_TICKET_MIN_PAYMENT: 'SET_TICKET_MIN_PAYMENT',
  SET_TOTAL_PAYMENT: 'SET_TOTAL_PAYMENT',
  SPLIT_PAYMENT_PER_BET: 'SPLIT_PAYMENT_PER_BET',
};
